// JAN シーズンコードの照会と entrydata への反映をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createJanSeasonService(deps) {
    const {
        DicVal,
        assignEntryDataCurrent,
        dispatch,
        entrydata,
        entrydataRef,
        entryrerender,
        fnc,
        isEmpty,
        lastHbSeasonCodeRef,
        protectHbSeasonCommit,
        rerender
    } = deps;

    function setJanSeasonCodeOnEntryData(targetData, value) {
        if (isEmpty(targetData)) return false;
        const text = String(isEmpty(value) ? "" : value).trim();
        if (String(DicVal(targetData, "PDT_JANSEASONCD", "")).trim() === text) return false;
        targetData.PDT_JANSEASONCD = text;
        return true;
    }
    function loadJanSeasonCode(hbSeasonCode, options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        if (isEmpty(targetData)) return;

        const requestHbSeasonCode = String(isEmpty(hbSeasonCode) ? DicVal(targetData, "PDT_HBSEASONCD", "") : hbSeasonCode).trim();

        if (isEmpty(requestHbSeasonCode)) {
            lastHbSeasonCodeRef.current = "";
            const cleared = setJanSeasonCodeOnEntryData(targetData, "");
            if (!cleared) return;
            assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
            return;
        }

        if (!DicVal(requestOptions, "force", false) && lastHbSeasonCodeRef.current === requestHbSeasonCode) {
            return;
        }
        lastHbSeasonCodeRef.current = requestHbSeasonCode;

        fnc.current.postaxios("hinbanmaster/GetJanSeasonCode",
            { HbSeasonCode: requestHbSeasonCode },
            {
                onSuccess: function (data) {
                    const nextValue = String(DicVal(data.returnData, "PDT_JANSEASONCD", "")).trim();

                    const changed = setJanSeasonCodeOnEntryData(targetData, nextValue);
                    if (!changed) return;
                    assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
                    dispatch(entrydata({ ...entrydataRef.current }));
                    dispatch(entryrerender());
                },
                onError: function (data) {
                    lastHbSeasonCodeRef.current = "";
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "JANシーズンコードの取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }

    return {
        setJanSeasonCodeOnEntryData,
        loadJanSeasonCode
    };
}
